import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram, Facebook, ArrowUpRight } from 'lucide-react';

const SiteFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0f2419] text-white relative">
      {/* Partners Bar */}
      <div className="border-b border-[#c9a962]/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16">
            <div className="text-center">
              <p className="font-montserrat text-[9px] tracking-[0.2em] uppercase text-white/30 mb-1">Aménageur territorial</p>
              <p className="font-playfair text-base text-[#c9a962]">One Green Dev</p>
            </div>
            <div className="hidden md:block w-px h-8 bg-[#c9a962]/15" />
            <div className="text-center">
              <p className="font-montserrat text-[9px] tracking-[0.2em] uppercase text-white/30 mb-1">Architecture</p>
              <p className="font-playfair text-base text-white/70">Nicolas Duchateau</p>
            </div>
            <div className="hidden md:block w-px h-8 bg-[#c9a962]/15" />
            <div className="text-center">
              <p className="font-montserrat text-[9px] tracking-[0.2em] uppercase text-white/30 mb-1">Parcours Golf</p>
              <p className="font-playfair text-base text-white/70">Alain Cnrjac</p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          {/* Logo */}
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 border-2 border-[#c9a962] flex items-center justify-center">
              <span className="font-playfair font-bold text-xl text-[#c9a962]">LGS</span>
            </div>
            <div>
              <span className="font-playfair text-xl text-white">Le Golf de Songon M'braté</span>
              <p className="font-montserrat text-[10px] tracking-[0.2em] uppercase text-[#c9a962]">
                Prestige & Excellence
              </p>
            </div>
          </div>

          {/* Social Links */}
          <div className="flex gap-4">
            {[Linkedin, Instagram, Facebook].map((Icon, index) => (
              <a 
                key={index}
                href="#" 
                className="w-10 h-10 border border-[#c9a962]/30 flex items-center justify-center hover:border-[#c9a962] hover:bg-[#c9a962]/10 transition-all"
              >
                <Icon className="w-4 h-4 text-[#c9a962]" />
              </a>
            ))}
          </div>

          {/* Ecosystem Link */}
          <a
            href="https://onegreendev.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 font-montserrat text-white/50 hover:text-[#c9a962] text-sm transition-colors"
          >
            One Green Dev
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      </div>

      {/* Bottom Bar - Minimal */}
      <div className="border-t border-[#c9a962]/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-montserrat text-white/30 text-xs">
              © {currentYear} Le Golf de Songon M'braté • Tous droits réservés • Site réalisé par{' '}
              <a href="https://www.relaisit.com" target="_blank" rel="noopener noreferrer" className="text-[#c9a962]/60 hover:text-[#c9a962] transition-colors">
                Relais IT
              </a>
            </p>
            <div className="flex items-center gap-6">
              <a
                href="mailto:contact@onegreendev.com"
                className="font-montserrat text-white/40 hover:text-[#c9a962] text-xs transition-colors"
              >
                contact@onegreendev.com
              </a>
              <span className="text-white/20">|</span>
              <a
                href="tel:+2250705509738"
                className="font-montserrat text-white/40 hover:text-[#c9a962] text-xs transition-colors"
              >
                +225 07 05 50 97 38
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
